/**
 * @fileoverview โหลด Google Maps ผ่าน useJsApiLoader ตัวเดียวกับคอมโพเนนต์แผนที่อื่น
 * ใช้แทน <LoadScript> ในหน้า class component — LoadScript ไม่ render ลูกถ้ามี window.google อยู่แล้ว
 * (เช่นเปิดแผนที่ GPS ในใบงานก่อน) และตอน unmount ลบ script ทิ้งทำให้แผนที่หน้าอื่นต้องโหลดใหม่
 * โหลดไม่สำเร็จ/Google ปฏิเสธคีย์ = ข้อความ + ปุ่มลองใหม่ แทนหน้า Error ของ Google
 * @module components/maps/MapsLoader
 */
import React, { useCallback, useState } from 'react';
import { useJsApiLoader } from '@react-google-maps/api';
import MapsLoadError from './MapsLoadError';
import {
  GOOGLE_MAPS_API_KEY,
  GOOGLE_MAPS_LIBRARIES,
  GOOGLE_MAPS_LOADER_ID,
  retryLoadMaps,
  useMapsAuthFailed,
} from '../../utils/googleMaps';

function MapsLoaderInner({ children, onRetry }) {
  const authFailed = useMapsAuthFailed();
  const { isLoaded, loadError } = useJsApiLoader({
    id: GOOGLE_MAPS_LOADER_ID,
    googleMapsApiKey: GOOGLE_MAPS_API_KEY,
    libraries: GOOGLE_MAPS_LIBRARIES,
  });
  if (loadError || authFailed) return <MapsLoadError onRetry={onRetry} />;
  if (!isLoaded) return null;
  return <>{children}</>;
}

export default function MapsLoader({ children }) {
  const [attempt, setAttempt] = useState(0);
  const handleRetry = useCallback(() => {
    if (!retryLoadMaps()) setAttempt((value) => value + 1);
  }, []);
  return (
    <MapsLoaderInner key={attempt} onRetry={handleRetry}>
      {children}
    </MapsLoaderInner>
  );
}
